export const appConfigs = {
    app_name: process.env.REACT_APP_NAME,
    job_description: process.env.REACT_APP_DESCRIPTION,
    api_url: process.env.REACT_APP_API_URL,
    auth_key: process.env.REACT_APP_AUTH_KEY,
    recaptcha_site_key: "6LeC8ssUAAAAALNHMZM8kJ9dqg7SHDUSQUXQnQvE",
    apps_limit: 4,
    search_limit: 4,
};